module.exports = __webpack_public_path__ + "img/toekomstig.b8834027.jpg";